export default __webpack_public_path__ + "static/media/wallpaper_01.6150db27.jpg";